import { render, staticRenderFns } from "./DependentRelationVisa.vue?vue&type=template&id=823aa234&"
import script from "./DependentRelationVisa.vue?vue&type=script&lang=js&"
export * from "./DependentRelationVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports